"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.saveWebSessionIdWhenActive = exports.saveWebSessionIdInCookies = exports.getWebSessionId = void 0;
var logger_1 = require("../logger");
var strings_1 = require("../util/strings");
var js_cookie_1 = __importDefault(require("js-cookie"));
var clientId_1 = require("../clientId");
var throttle_1 = __importDefault(require("lodash/throttle"));
var once_1 = __importDefault(require("lodash/once"));
var parse_domain_1 = require("@snapchat/parse-domain");
var log = (0, logger_1.getLogger)("webSessionId");
var COOKIE_NAME = "blizzard_web_session_id";
var webSessionId = undefined;
function getWebSessionId() {
    if (clientId_1.cookiesEnabled) {
        webSessionId = js_cookie_1["default"].get(COOKIE_NAME);
        if (webSessionId !== undefined) {
            log.info("Loaded blizzardWebSessionId from cookies:", webSessionId);
        }
        else {
            webSessionId = generateAndSaveWebSessionIdInCookies();
        }
    }
    else {
        return "";
    }
    return webSessionId;
}
exports.getWebSessionId = getWebSessionId;
function generateAndSaveWebSessionIdInCookies() {
    var webSessionId = (0, strings_1.generateBase64UUId)();
    saveWebSessionIdInCookies(webSessionId);
    log.info("Generated new webSessionId and saved in cookies:", webSessionId);
    return webSessionId;
}
function saveWebSessionIdInCookies(webSessionId) {
    js_cookie_1["default"].set(COOKIE_NAME, webSessionId, {
        expires: 1 / 48,
        domain: (0, parse_domain_1.getTopLevelDomain)(self.location.hostname)
    });
    log.info("Saved current webSessionId in cookies");
}
exports.saveWebSessionIdInCookies = saveWebSessionIdInCookies;
var EVENTS_ARRAY = [
    "keypress",
    "keydown",
    "click",
    "contextmenu",
    "dblclick",
    "mousemove",
    "scroll",
    "touchmove",
    "touchstart",
    "mousedown",
    "keyup",
];
exports.saveWebSessionIdWhenActive = (0, once_1["default"])(function () {
    if (!clientId_1.cookiesEnabled) {
        return;
    }
    var throttleFn = (0, throttle_1["default"])(function () {
        saveWebSessionIdInCookies(getWebSessionId());
    }, 1000);
    for (var i = 0; i < EVENTS_ARRAY.length; i++) {
        window.addEventListener(EVENTS_ARRAY[i], throttleFn);
        log.info("set eventListener for", EVENTS_ARRAY[i]);
    }
});
//# sourceMappingURL=webSessionId.js.map